import type { IconNode } from '../types';

/**
 * @name cow-udder-droplets
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMiAyYzAgMiAuNiA0IDEuNyA1LjVMMi4zIDEwYTIgMiAwIDAgMCAzLjQgMmwuOS0xLjZjMSAuNiAyLjEgMS4xIDMuNCAxLjRWMTRhMiAyIDAgMCAwIDQgMHYtMi4yYTguNSA4LjUgMCAwIDAgMy40LTEuNGwuOSAxLjZhMS45NCAxLjk0IDAgMSAwIDMuNC0ybC0xLjQtMi41QzIxLjQgNiAyMiA0IDIyIDJaIiAvPgogIDxwYXRoIGQ9Ik03LjkgMTguNmMtLjYtLjYtMS4xLTEuMy0xLjQtMi4xLS4zLjgtLjggMS41LTEuNCAyLjFhMS45MyAxLjkzIDAgMSAwIDIuOCAwIiAvPgogIDxwYXRoIGQ9Ik0xOC45IDE4LjZjLS42LS42LTEuMS0xLjMtMS40LTIuMS0uMy44LS44IDEuNS0xLjQgMi4xYTEuOTMgMS45MyAwIDEgMCAyLjggMCIgLz4KPC9zdmc+Cg==) - https://lucide.dev/icons/cow-udder-droplets
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const cowUdderDroplets: IconNode = [
  [
    'path',
    {
      d: 'M2 2c0 2 .6 4 1.7 5.5L2.3 10a2 2 0 0 0 3.4 2l.9-1.6c1 .6 2.1 1.1 3.4 1.4V14a2 2 0 0 0 4 0v-2.2a8.5 8.5 0 0 0 3.4-1.4l.9 1.6a1.94 1.94 0 1 0 3.4-2l-1.4-2.5C21.4 6 22 4 22 2Z',
      key: '1l09mx',
    },
  ],
  [
    'path',
    {
      d: 'M7.9 18.6c-.6-.6-1.1-1.3-1.4-2.1-.3.8-.8 1.5-1.4 2.1a1.93 1.93 0 1 0 2.8 0',
      key: '1ue09r',
    },
  ],
  [
    'path',
    {
      d: 'M18.9 18.6c-.6-.6-1.1-1.3-1.4-2.1-.3.8-.8 1.5-1.4 2.1a1.93 1.93 0 1 0 2.8 0',
      key: '17wltm',
    },
  ],
];

export default cowUdderDroplets;
